/**
 * SeasonDropdown
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Dropdown } from 'semantic-ui-react';

// Actions
import { setCurrentSeasonId } from '../../services/currentSeasonId/actions';
import { deleteQueryString } from '../../services/router/actions';

// Selectors
import { selectCurrentSeasonId } from '../../services/currentSeasonId/selectors';
import { selectOptions } from './selectors';

interface Props {
    deleteQueryString: Function;
    setCurrentSeasonId: Function;
    seasonId?: string | string[];
    options: {
        key: number,
        text: string,
        value: number
    }[];
    direction?: boolean;
    selection?: boolean;
    fluid?: boolean;
    inline?: boolean;
}

export class SeasonDropdown extends React.Component<Props> {
    handleChange = (
        event: SyntheticInputEvent<EventTarget>,
        data: { value: number }
    ) => {
        const { seasonId } = this.props;
        if (data.value !== seasonId) {
            this.props.setCurrentSeasonId(data.value);
            this.props.deleteQueryString();
        }
    };

    render() {
        const {
            seasonId,
            options,
            direction,
            selection,
            fluid,
            inline
        } = this.props;
        if (!options || !options.length) return null;
        return (
            <Dropdown
                direction={direction}
                selection={selection}
                fluid={fluid}
                inline={inline}
                selectOnBlur={false}
                lazyLoad
                value={seasonId}
                options={options}
                onChange={this.handleChange}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    seasonId: selectCurrentSeasonId,
    options: selectOptions
});

export default connect(
    mapStateToProps,
    { setCurrentSeasonId, deleteQueryString }
)(SeasonDropdown);
